import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../../services/productservice';
const CAT_TESTIMONIAL: string = 'destination';
@Component({
  selector: 'app-home-testimonial',
  templateUrl: './home-testimonial.component.html',
  styleUrls: ['./home-testimonial.component.scss'],
})
export class HomeTestimonialComponent implements OnInit {
  [x: string]: any;
  TestMonialData: any[] = [];
  testimonialResponsive: any;
  constructor(private productService: ProductService) {}

  ngOnInit(): void {
    this.getTestiMonial();
  }

  getTestiMonial() {
    try {
      this.productService.getTestiMonial().then((res: any) => {
        this.TestMonialData = res.filter(
          (item: any) => item.field_special_intrest.toLowerCase() === CAT_TESTIMONIAL.toLowerCase()
        );
        if (this.TestMonialData.length > 0) {
          setTimeout(() => {
            ($('.testimonial-flipster') as any).flipster({
              style: 'flat',
              buttons: true,
              scrollwheel: false,
              loop: true,
              spacing: -0.05,
            });
          }, 1000);
        }
      });
    } catch (error) {}
  }
}
